import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { education } from '../../data/constants';
import EducationCard from '../Cards/EducationCard';

gsap.registerPlugin(ScrollTrigger);

const Section = styled.section`
  padding: 100px 5vw;
  background: ${({ theme }) => theme.bgLight};
`;

const Wrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const Label = styled.p`
  font-family: 'Space Grotesk', monospace;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 12px;
`;

const Title = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: clamp(32px, 4vw, 48px);
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  letter-spacing: -0.02em;
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Education = () => {
  const headerRef = useRef(null);
  const gridRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(headerRef.current,
      { y: 40, opacity: 0 },
      {
        y: 0, opacity: 1, duration: 0.8, ease: 'power3.out',
        scrollTrigger: { trigger: headerRef.current, start: 'top 85%' }
      }
    );

    const items = gridRef.current?.querySelectorAll(':scope > *');
    if (items?.length) {
      gsap.fromTo(items,
        { y: 30, opacity: 0 },
        {
          y: 0, opacity: 1, duration: 0.6, ease: 'power3.out',
          stagger: 0.15,
          scrollTrigger: { trigger: gridRef.current, start: 'top 82%' }
        }
      );
    }
  }, []);

  return (
    <Section id="education">
      <Wrapper>
        <Header ref={headerRef}>
          <Label>Background</Label>
          <Title>Education</Title>
        </Header>
        <Grid ref={gridRef}>
          {education.map((edu, index) => (
            <EducationCard key={index} education={edu} />
          ))}
        </Grid>
      </Wrapper>
    </Section>
  );
};

export default Education;
